<div class="block-schedule__top">
    <ridango-ui-back-button>
        <a [routerLink]="'/schedule/routes' | localize">{{ 'LOCAL_BTN_BACK' | translate }}</a>
    </ridango-ui-back-button>
    <h1>{{'SCHEDULE_ROUTE_DIRECTION_SELECTION_TITLE' | translate}}</h1>
    <p>{{'SCHEDULE_ROUTE_DIRECTION_SELECTION_DESCRIPTION' | translate}}</p>
</div>

<div class="block-schedule__bottom">
    <ul class="remove-bullets route-list">
        <li *ngFor="let id of routeDirectionIds">
            <a class="link link--no-line link--no-hover flex-center full-width min-height-60"
                [routerLink]="['/schedule/routes', routeId, 'directions', id]  | localize"
                (click)="selectDirectionId(id)" (keydown.enter)="selectDirectionId(id)"
                (keydown.space)="selectDirectionId(id)">
                <span role="text" aria-label="route number 1" class="flex-center route-list--number">
                    {{ routeDirections[id].route_short_name }}
                </span>

                <div class="flex flex1 position-relative min-height-50 padding-10">
                    <span class="flex1 margin-right-10 align-self-center" role="text">
                        {{ routeDirections[id].trip_short_name }}
                    </span>

                    <span class="icon icon-arrow-right-link align-self-center"></span>

                    <div class="route-list--hr"></div>
                </div>
            </a>
        </li>
    </ul>
</div>
